// @flow
import {markerReset, markerSet} from "../reducers/filterReducer";
import {setCategorySelectionSource} from "../helper/tracker/internalEvents";

export const setMarker = (marker = [], selectionSource: ?string = null) => {
	return dispatch => {
		if (selectionSource) setCategorySelectionSource(selectionSource);
		dispatch(markerSet(marker));
	};
};

export const resetMarker = () => {
	return dispatch => {
		dispatch(markerReset());
	};
};
